import { CustomButton } from 'components/shared/CustomButton';
import { IQuestionModel, IQuestionTypeModel } from 'models/QuestionType.Model'
import React, { InputHTMLAttributes, useEffect, useRef, useState } from 'react'
import { Button, Col, Row } from 'reactstrap';

interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    data: Array<IQuestionTypeModel>,
    item: IQuestionTypeModel,
    index: any,
    elementRef: any,
    clickHandler: any,
    questionIndex: number,
    isDummy: boolean,
    orderData: Array<IQuestionModel>
}


function YesNoQuestions({ data, item, index, elementRef, clickHandler, questionIndex, isDummy, orderData, ...rest }: inputProps, ref) {
    const subQuestions = data.filter(options => options.ParentId === item.Identifier);
    const [showOptionSection, setShowOptionSection] = useState<any>(orderData.find(x => x.QuestionnaireTemplateId == item.Id)?.Selected);
    const multiSelectRef = useRef(null) as any;

    const [activeSection, setActiveSection] = useState<"Yes" | "No" | "">("");

    const onToggleClick = async (toggleValue?: boolean) => {
        if (toggleValue == true) {
            setActiveSection("Yes");
        }
        else {
            setActiveSection("No");
        }
        setShowOptionSection(toggleValue ?? false);
        clickHandler(toggleValue, item, index);
    };

    const onOptionChange = (value: boolean, question: IQuestionTypeModel) => {
        clickHandler(value, question, index);
    }

    const setButtonColor = (buttonYes: boolean) => {
        if (showOptionSection === undefined) {
            return 'bg-light text-dofy';
        }
        if (buttonYes) {
            return showOptionSection ? 'bg-dofy text-light' : 'bg-light text-dofy';
        }

        return showOptionSection === false ? 'bg-danger text-light' : 'bg-light text-dofy';
    };
    return (
        <React.Fragment>
            <Row>
                <Col ref={elementRef} xl={12}>
                    <Row>
                        <Col xl={8} lg={8} md={8} sm={12} xs={12}>
                            <div>
                                <p className={`m-0 ${isDummy ? "text-dofy-mute" : "text-dofy"} fw-semibold`}>{index + 1}. {item.DisplayName}</p>
                            </div>
                            {item.SubHeading &&
                                <Row>
                                    <p className={`${isDummy ? "text-dofy-mute" : "text-info"} fw-thin font-size-11`}>{item.SubHeading}</p>
                                </Row>}
                        </Col>
                        <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                            <div className='mx-2 mb-3'>
                                {isDummy ?
                                    <Row className='mx-2'>
                                        <div className={`align-middle text-center p-1 rounded-2  me-2 `} style={{ width: '46%' }}>
                                            <p className='m-0' >Yes</p>
                                        </div>
                                        <div className={`align-middle text-center p-1 rounded-2 me-2`} style={{ width: '46%' }}>
                                            <p className='m-0' >No</p>
                                        </div>
                                    </Row>
                                    :
                                    <Row className='mx-2'>
                                        <div className={`align-middle text-center p-1 rounded-2 cursor-pointer me-2 ${setButtonColor(true)}`} onClick={() => onToggleClick(true)} style={{ width: '46%' }}>
                                            <p className='m-0' onClick={() => onToggleClick(true)}>Yes</p>
                                        </div>
                                        <div className={`align-middle text-center p-1 rounded-2 cursor-pointer me-2 ${setButtonColor(false)}`} onClick={() => onToggleClick(false)} style={{ width: '46%' }}>
                                            <p className='m-0' onClick={() => onToggleClick(false)}>No</p>
                                        </div>
                                    </Row>
                                }
                                {/* <CustomButton type={'button'} btnClassName={`me-2 btn-success`} iconClasssName={undefined} name={'Yes'} onClick={() => onToggleClick(true)} /> */}
                                {/* <Button onClick={() => onToggleClick(true)} color={`${setButtonColor(true)}`} className={`btn-success ${setButtonColor(true)}`}>Yes</Button> */}
                                {/* <CustomButton type={'button'} btnClassName={`btn-soft-dark ${setButtonColor(false)}`} iconClasssName={undefined} name={'No'} onClick={() => onToggleClick(false)} /> */}
                            </div>
                        </Col>
                    </Row>
                    {/* <p id={`err-yesno-text-${item.Id}`} className="err-yesno-text err-yesno-text-hide text-danger">Please specify a answer for question.</p> */}
                </Col>
            </Row>

        </React.Fragment>
    )
}

export default YesNoQuestions
